<div class="message-card">
  <div class="error-icon">
    <img ngSrc="/utest-static/assets/images/registration/question.svg" alt="" height="40" width="40"/>
  </div>

  <h1 class="title">Something Went Wrong</h1>

  <div class="message-body">
    <p>It seems you might already have an account. Return to the login page and try again. If the problem persists, please reach out to
      <a href="http://support.utest.com/csp/csp/tester-support" class="help-link" target="_blank">tester support</a> for
      assistance.
    </p>
    <a href="/login" class="btn-login">
      Back to Login
    </a>
  </div>

  <div class="help-section">
    <p class="help-text">
      Still having issues or need help? Contact us at
      <a href="http://support.utest.com/csp" class="help-link" target="_blank">support.utest.com</a>
    </p>
  </div>
</div>
